module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAcklEQVR42u3asQ0AMAgDQe+/NNkg6SjiQ/oeXUVBZibNBQAAAAAAAAAAAAAAADuT3NsbAAAAAAAAAAAAAAAAAAAAAMBrsd8CAAAAAAAAADiEAAAAAAAAAAAAAAAAAAAAgG4An6IAAAAAAAAAAAAAAPR0AIQsb17RbOTRAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/England.png
// module id = FaXu
// module chunks = 0 62 63